import * as Yup from 'yup';
export const pageOneSchema = Yup.object().shape({
  title: Yup.string()
    .max(40, 'کمتر از 40 کاراکتر وارد کنید')
    .required('عنوان آگهی ضروری می باشد.'),
});
